export const severity = {
  appeal: ["divide-divider border-divider bg-component"],
  info: ["divide-divider border-divider bg-canvas-alt"],
  error: ["divide-divider-danger", "border-divider-danger", "text-fg-danger", "bg-canvas-danger-card"],
  warning: ["divide-divider-warning", "border-divider-warning", "text-fg-warning", "bg-canvas-warning-card"],
  success: ["divide-divider-positive", "border-divider-positive", "text-fg-positive", "bg-canvas-positive-card"],
}

export type Severity = "info" | "warning" | "error" | "success" | "appeal"
